import styled from 'styled-components';

export const GridContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 200px;
    height: 100%;
`;